export const SIDE_NAV_WIDTH = 220;
export const DEFAULT_LAYOUT_WIDTH = 1200;

export const NAVBAR_HEIGHT = 65;
export const NAVBAR_HEIGHT_MOBILE = 56;

export const TABLE_GRID_SIZE = 15;
export const TABLE_GRID_CELL_PX = 72;
export const TABLE_GRID_GAP_PX = 8;
export const TABLE_GRID_PADDING_PX = 16;
export const TABLE_CROP_MARGIN_CELLS = 1;

export const TABLE_DETAIL_COLUMN_PX = 290;
export const TABLE_VIEW_HEIGHT_PX = 600;

export const TABLE_LIST_NUMBER_COLUMN_PX = 56;
export const TABLE_LIST_RING_COLUMN_PX = 40;
export const TABLE_LIST_ORDER_COLUMN_PX = 56;
export const TABLE_LIST_AMOUNT_COLUMN_PX = 96;
export const TABLE_LIST_STATUS_COLUMN_PX = 76;

export const TABLE_LIST_GRID_TEMPLATE = `${TABLE_LIST_NUMBER_COLUMN_PX}px ${TABLE_LIST_RING_COLUMN_PX}px 1fr ${TABLE_LIST_ORDER_COLUMN_PX}px ${TABLE_LIST_AMOUNT_COLUMN_PX}px ${TABLE_LIST_STATUS_COLUMN_PX}px`;

export const TABLE_POLL_INTERVAL_MS = 60_000;
export const TABLE_CLOCK_TICK_MS = 30_000;

export const DRAG_ACTIVATION_DISTANCE_PX = 5;
export const TOUCH_DRAG_DELAY_MS = 250;
export const TOUCH_DRAG_TOLERANCE_PX = 5;
export const MAX_TABLE_COUNT = 100;

export const TRAY_DROPPABLE_ID = 'tray';
